export enum PurchaseOrderEnums {
  stateOpen = 1,
  stateAnnul = 2,
  stateInitialClose = 3,
  stateFinalClose = 4,

  wayToPayCredit = 1,
  wayToPayCash = 2,
}